import { render, staticRenderFns } from "./InventoryTrainingPage.vue?vue&type=template&id=4df085fc"
import script from "./InventoryTrainingPage.vue?vue&type=script&lang=js"
export * from "./InventoryTrainingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports